module.exports = __webpack_public_path__ + "static/media/password.8b190847.png";